import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import AffordabilitySimulator from "@/pages/AffordabilitySimulator";

export const Route = createFileRoute("/affordability-simulator")({
  head: () => seoHead("/affordability-simulator"),
  component: AffordabilitySimulator,
});
